<template>
  <pt-scan-payment-counselor class="pt-scan-payment-counselor__page"></pt-scan-payment-counselor>
</template>

<script>
import PtScanPaymentCounselor from 'cps/finance-manage/pt-scan-payment-counselor/withData'
export default {
  name: 'pt-scan-payment-counselor__view',
  components: {
    'pt-scan-payment-counselor': PtScanPaymentCounselor
  }
}
</script>
